import { render, staticRenderFns } from "./intro-components.vue?vue&type=template&id=5f6f2a8b&"
import script from "./intro-components.vue?vue&type=script&lang=js&"
export * from "./intro-components.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports